<template>

  <div class="circle">
    <l-circle ref="element"
               :lat-lng="center"
               :radius="element.locations.radius"
               :fillColor="color"
               :color="color"
               :weight="weight"
               :bubblingMouseEvents="false"
               :options="{ editable: true }"
               @contextmenu="contextmenu($event)"
               @click="click($event)">
    </l-circle>
  </div>

</template>

<script>

import { LCircle } from 'vue2-leaflet'
import { MapService } from '../../services/map.service.es6'

export default {
  name: 'map-circle',

  props: [ 'element', 'active' ],

  data () {
    return {
      editable: false,
      menu: [
        { title: this.$t('map.element.edit'), icon: 'pen', action: () => this.editable = true },
        { title: this.$t('map.element.remove'), icon: 'trash', action: () => MapService.removeElement(this.element) }
      ]
    }
  },

  computed: {
    color () {
      return this.active ? '#FF0000' : '#333333'
    },

    weight () {
      return this.active ? 3 : 1
    },

    center () {
      return [ this.element.locations.center.lat, this.element.locations.center.lng ]
    }
  },

  methods: {
    click(event) {
      this.$emit('click', event)
    },

    contextmenu (event) {
      this.$emit('menu', { event: event, data: this.menu })
    },
  },

  watch: {
    active (value) {
      if (this.editable && !value) {
        this.editable = false

        const object = this.$refs.element.mapObject
        this.$emit('save', { locations: {
          center: { lat: object._latlng.lat, lng: object._latlng.lng },
          radius: object._mRadius
        } })
      }
    },

    editable (value) {
      const editor = this.$refs.element.mapObject.enableEdit()

      if (value)
        editor.enable()
      else
        editor.disable()
    }
  },

  components: {
    LCircle
  }
}
</script>
